import React, { useState, useEffect, useContext } from 'react';
import api from '../utils/api';
import StudentListPopup from './StudentListPopup';
import PublicStudentListPopup from './PublicStudentListPopup';
import './styles/TransferInventoryPage.css';
import { BsFiles } from "react-icons/bs";
import { useNavigate } from 'react-router-dom'; 

const OtherExpenseFormPage = () => {
    const [typeList, setTypeList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [type, setType] = useState('');
    const [branch, setBranch] = useState('');
    const [needBranch, setNeedBranch] = useState(false);
    const [purchaseDate, setPurchaseDate] = useState('');
    const [purchaseAmount, setPurchaseAmount] = useState(0);
    const [purchaseMethod, setPurchaseMethod] = useState('');
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [rentTypeId, setRentTypeId] = useState(null);
    const [otherTypeId, setOtherTypeId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        api.get('/utils/getOtherExpenseTypeList')
          .then(response => setTypeList(response.data.data.typeList))
          .catch(error => console.error('Error fetching program list:', error));

        
        api.get('/utils/getBranchList')
          .then(response => setBranchList(response.data.data.branchList))
          .catch(error => console.error('Error fetching branch list:', error));
          
    }, []);

    useEffect(() => {
        const rentType = typeList.find(type => type.type_name === 'RENT');
        const otherType = typeList.find(type => type.type_name === 'OTHER');
        
        
        if (rentType) {
            setRentTypeId(rentType.type_id); // Store FIELD TRIP type ID
        } 
        if (otherType) {
            setOtherTypeId(otherType.type_id); // Store TODDLER type ID
        }
    }, [typeList]);

    useEffect(() => {
        if (type == rentTypeId || type == otherTypeId){
            setNeedBranch(true);
        } else {
            setNeedBranch(false);
        }
    }, [type]);
    
    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };

    const validateForm = () => {
        const errors = {};
    
        // Cek jika field kosong
        
        if (!type) errors.type = 'Expense Type is required';
        if (!purchaseMethod) errors.purchaseMethod = 'Purchase Method is required';
        if (!purchaseDate) errors.purchaseDate = 'Purchase Date is required';
        if (purchaseAmount==0) errors.purchaseAmount = 'Purchase amount is required';
        if (!description) errors.description = 'Description is required';

        return errors;
    };
   
    const handleSubmit = () => {
        
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            console.log('Validation Errors:', validationErrors);
        } else {
            const confirmation = window.confirm('Are you sure you want to proceed with this action?');
            if (!confirmation) {
                return;
            }

            const expenseData = {
                data: {
                    expenseData: {
                        purchase_date: purchaseDate,
                        purchase_amount: purchaseAmount, 
                        purchase_method: purchaseMethod,
                        branch_id: branch,
                        type_id: type,
                        description: description
                    },
                },
            };

            
            
            
            console.log(expenseData);
        
            api.post(`expense/save`, expenseData)
            .then(response => {
                const successMessage = response.data.message;
                console.log(successMessage);
                navigate('/success', { state: { message: successMessage } });
                
            })
            .catch(error => {
                console.error('Error adding student:', error);
                navigate('/error', { state: { message: 'Please ask to administrator!' } });
            });
        }
    
        

    };


    const handlePriceChange = (e) => {
        const value = e.target.value.replace(/\./g, ''); // Hapus titik
        if (value === '') {
            setPurchaseAmount(0);
        } else {
            setPurchaseAmount(parseFloat(value)); // Simpan sebagai angka
        }
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Input Other Expense</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Class Data</h3>
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Expense Type</label>
                                    </td>
                                    <td>
                                        <select value={type} onChange={(e) => setType(e.target.value)}>
                                            <option value="">Select Type</option>
                                            {typeList.map(type => (
                                                <option key={type.type_id} value={type.type_id}>
                                                    {type.type_name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.type && 
                                    <td>
                                        <div className="error-message">{errors.type}</div>
                                    </td>
                                    }
                                </tr>
                                {needBranch &&
                                <tr>
                                    <td>
                                        <label>Branch</label>
                                    </td>
                                    <td>
                                        <select value={branch} onChange={(e) => setBranch(e.target.value)}>
                                            <option value="">Select Branch</option>
                                            {branchList.map(branch => (
                                                <option key={branch.branch_id} value={branch.branch_id}>
                                                    {branch.branch_name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                }
                                {needBranch &&
                                <tr>
                                    {errors.branch && 
                                    <td>
                                        <div className="error-message">{errors.branch}</div>
                                    </td>
                                    }
                                </tr>
                                }
                                <tr>
                                    <td>
                                        <label>Purchase Amount</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="text"     
                                            value={formatCurrency(purchaseAmount)}  
                                            onChange={handlePriceChange} 
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    {errors.purchaseAmount && 
                                    <td>
                                        <div className="error-message">{errors.purchaseAmount}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Purcase Date</label>
                                    </td>
                                    <td>
                                        <input type="date" value={purchaseDate} onChange={(e) => setPurchaseDate(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    {errors.purchaseDate && 
                                    <td>
                                        <div className="error-message">{errors.purchaseDate}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Purcase Method</label>
                                    </td>
                                    <td>
                                        <select value={purchaseMethod} onChange={(e) => setPurchaseMethod(e.target.value)} >
                                            <option key="" value="">Choose Payment Method</option>
                                            <option key="BANK BCA" value="BANK BCA">BANK BCA</option>
                                            <option key="BANK BRI" value="BANK BRI">BANK BRI</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.purchaseMethod && 
                                    <td>
                                        <div className="error-message">{errors.purchaseMethod}</div>
                                    </td>
                                    }
                                </tr>
                                <tr>
                                    <td>
                                        <label>Description</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <textarea value={description} onChange={(e) =>setDescription(e.target.value)} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    {errors.description && 
                                    <td>
                                        <div className="error-message">{errors.description}</div>
                                    </td>
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="search-container">
                        <button className="profile-button" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </div>
    );
};

export default OtherExpenseFormPage;
